const workingHours = [
  {
    name: "4 hours",
    value: "FOUR",
  },
  {
    name: "6 hours",
    value: "SIX",
  },
  {
    name: "8 hours",
    value: "EIGHT",
  },
];

export default workingHours;
